import {Injectable} from '@angular/core';
import {CONFIGURATION} from '../../../constants/configuration';
import _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class FrameService {

    FPS_NUMBER_CONST = CONFIGURATION.FPS_CONST;

    getFrame(time) {
        return time * this.FPS_NUMBER_CONST;
    }

    getRoundFrame(time) {
        return Math.ceil(time * this.FPS_NUMBER_CONST);
    }

    getFloorFrame(time) {
        return Math.floor(time * this.FPS_NUMBER_CONST);
    }

    getFrameRange(timeStart: number, timeEnd: number): number[] {
    /*
      _.range creates array of numbers from start up to, but not including end, so sometimes when timeStart and timeEnd was near
      same frame getFrameRange method was returning empty array. That was causing issues with missing frames on some devices, so some of
      jump actions was not working.
      To prevent this issue timeStart has been changed to be rounded down, so in that case getFrameRange method will always return array
      with one item at least.
      However this change caused that in frame-accurate.component.ts on timer tick some frames are returned many times (duplicated frames).
      For now, that's not a problem, but keep that in mind when adding support for new actions.
     */
        return _.range(this.getFloorFrame(timeStart), this.getRoundFrame(timeEnd));
    }

    numberOfFrameInAnimation(end, start) {
        if (end > start) {
            return end - start;
        }
    }

    getTimeFromFrame(frames) {
        return frames / this.FPS_NUMBER_CONST;
    }
}
